import { toast } from "react-toastify";
import { BaseApplicationService } from "../../../domain/base/base-application-service";
import {
  gqlClient,
  gqlHeader,
  runGqlQueryV2,
} from "../../../../graphql/client";

export type ProcManagementContextProps = {
  isAvailable: boolean;
  fetchOrgProducts: typeof ProcManagementService.prototype.fetchOrgProducts;
};

export class ProcManagementService extends BaseApplicationService<ProcManagementContextProps> {
  state = {
    isAvailable: false,
    fetchOrgProducts: this.fetchOrgProducts.bind(this),
  };

  async fetchOrgProducts(orgId: string) {
    const res = await runGqlQueryV2(() =>
      gqlClient.allOrgProductsByOrgId({ orgId }, gqlHeader("q")),
    );
    if (res.error) {
      toast.error("ポータルの製品情報の取得に失敗しました。");
      return;
    }
    const plan = res.data?.allOrgProductsByOrgId.find(
      (v) => v.productCode === "Portal",
    )?.plan;
    if (plan && plan !== "NotSet") {
      this.setState({
        isAvailable: true,
      });
    }
  }
}
